import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { handleLogout } from "../api/logout";
import { useAccountStorage } from "../hooks/useAccountStorage";
import { usePendingPartnershipCount } from "../hooks/usePartnerships";
import { spaceForType } from "../utils/roles";
import { Avatar } from "./common/Avatar";
import { navItemsForSpace } from "./Navbar";
import {
  PROFILE_ACCOUNT_PATH,
  PROFILE_NAV_ITEMS,
} from "./screens/profile/profileNav";

import Logo from "../assets/images/Logo.png";

export const MobileNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { getAccountStorage } = useAccountStorage();
  const accountStorage = getAccountStorage();
  const space = spaceForType(accountStorage?.type);
  const { count: pendingCount } = usePendingPartnershipCount(space !== "admin");
  const { t } = useTranslation();

  const handleLogoutClick = () => {
    handleLogout(navigate);
  };

  return (
    <>
      {/* Menu déroulant */}
      {accountStorage && (
        <div
          className={`fixed inset-0 z-40 ${
            isMenuOpen ? "pointer-events-auto" : "pointer-events-none"
          }`}
          onClick={() => setIsMenuOpen(false)}
        >
          <div
            className={`absolute right-0 top-0 flex flex-col h-full w-full bg-tertiary p-4 overflow-y-auto transform transition-transform duration-300 ease-in-out ${
              isMenuOpen ? "translate-x-0" : "translate-x-full"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center pb-4 border-b border-grey-medium">
              <button
                onClick={(e) => {
                  navigate("/");
                  e.stopPropagation();
                  setIsMenuOpen(false);
                }}
                className="text-secondary-text hover:text-secondary"
              >
                <div className="flex items-center gap-2">
                  <img src={Logo} alt="Copernic" className="h-14" />
                </div>
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMenuOpen(false);
                }}
                className="text-secondary-text hover:text-secondary"
              >
                <FontAwesomeIcon icon="times" />
              </button>
            </div>
            <div>
              <div className="pt-4 w-full">
                <Link
                  id="tour-nav-profile"
                  onClick={() => setIsMenuOpen(false)}
                  to={PROFILE_ACCOUNT_PATH}
                  className="flex items-center gap-3 text-secondary-text hover:text-secondary"
                >
                  <div className="w-8 h-8 bg-secondary-text rounded-lg overflow-hidden">
                    <Avatar
                      value={accountStorage.avatar}
                      firstName={accountStorage.first_name}
                      lastName={accountStorage.last_name}
                      emojiClassName="text-lg"
                      initialsClassName="text-sm"
                    />
                  </div>
                  <div>
                    <p className="font-oxaniumMedium">
                      {accountStorage.first_name} {accountStorage.last_name}
                    </p>
                    <p className="text-sm text-grey-medium">
                      {accountStorage.company_name}
                    </p>
                  </div>
                </Link>

                <ul className="mt-3 pl-4 space-y-1">
                  {PROFILE_NAV_ITEMS.map((item) => (
                    <li key={item.id}>
                      <Link
                        onClick={() => setIsMenuOpen(false)}
                        to={item.link}
                        className={`flex items-center p-2 rounded-lg ${
                          location.pathname === item.link
                            ? "bg-secondary text-tertiary"
                            : "text-secondary-text hover:text-tertiary hover:bg-secondary transition-colors"
                        }`}
                      >
                        <FontAwesomeIcon icon={item.icon} className="w-4" />
                        <span className="font-oxaniumMedium pl-3">
                          {t(item.label)}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-3 pt-3 border-t border-grey-medium">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLogoutClick();
                  }}
                  className="flex p-3 items-center rounded-lg text-secondary-text hover:text-red-600 transition-colors"
                >
                  <FontAwesomeIcon icon="sign-out-alt" />
                  <span className="font-oxaniumMedium pl-4">
                    {t("navbar-logout")}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Navbar fixe */}
      <nav
        id="tour-nav"
        className="fixed bottom-0 left-0 right-0 z-50 bg-tertiary border-t-2 border-grey-light"
      >
        <div className="flex justify-around items-center p-4">
          {navItemsForSpace(space, accountStorage?.type).map((item) => (
            <Link
              key={item.link}
              id={`tour-nav-${item.text}`}
              to={item.link}
              className={`flex flex-col items-center ${
                location.pathname === item.link
                  ? "text-secondary"
                  : "text-secondary-text"
              }`}
            >
              <button onClick={() => setIsMenuOpen(false)}>
                <span className="text-xl relative">
                  {item.icon}
                  {item.text === "section_partnerships" && pendingCount > 0 && (
                    <span className="absolute -top-1 -right-3 min-w-[1.1rem] h-[1.1rem] px-1 flex items-center justify-center rounded-full bg-red-600 text-white text-[0.65rem] font-oxaniumMedium">
                      {pendingCount > 9 ? "9+" : pendingCount}
                    </span>
                  )}
                </span>
              </button>
            </Link>
          ))}
          <button
            id="tour-nav-more"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="flex flex-col items-center text-secondary-text text-xl"
          >
            <FontAwesomeIcon icon="ellipsis-h" />
          </button>
        </div>
      </nav>
    </>
  );
};
